class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.el = document.querySelector("[data-predictive-search]");
    this.input = this.el.querySelector('input[type="search"]');
    this.resultsContainer = document.querySelector("[data-results-container]");
    this.input.addEventListener("input", (e) => {
      const term = e.target.value.trim();
      if (!term.length) {
        this.resultsContainer.innerHTML = "";
        return;
      }
      this.getResults();
    });
  }

  getResults() {
    setTimeout(async () => {
      if (this.input.value === "") {
        this.resultsContainer.innerHTML = "";
      } else {
        try {
          const res =
            await fetch(`/search/suggest?q=${this.input.value}&resources[type]=query,article,product,page&resources[options]
          [unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku&section_id=predictive-search`);
          const text = await res.text();

          this.resultsContainer.innerHTML = text;

          this.resultsContainer
            .querySelectorAll("[data-query]")
            .forEach((button) => {
              const query = button.getAttribute("data-query");
              button.addEventListener("click", () => {
                this.input.value = query;
                this.getResults(query);
              });
            });

          if (
            this.resultsContainer.querySelector("#predictive-search-results")
              .innerHTML == ""
          ) {
            this.resultsContainer.querySelector(
              "#predictive-search-results",
            ).innerHTML = "No Results";
          }
        } catch (err) {
          console.log(err);
        }
      }
    }, 500);
  }
}

customElements.define("predictive-search", PredictiveSearch);
